import { IS_LOADING } from '@/store/types/root/actions-types';
import { SHIFT_CREATE_REQUEST, SHIFT_UPDATE_REQUEST, SHIFT_DELETE_REQUEST, GET_SHIFTS_REQUEST } from './action-types';
import {ADD_SHIFTS_TO_LIST, ADD_SHIFT_TO_LIST, DELETE_SHIFT_FROM_LIST, UPDATE_SHIFT_IN_LIST} from "./mutation-types"
import api from "@/api/api"

export default {

    [GET_SHIFTS_REQUEST]: async ({  commit })=>{
        let response = {}
        try {
            response =   await api.get("/catalogs/shifts")
            if(response.data.statusCode === 200){
                const reponseBody = response.data.body
                commit(ADD_SHIFTS_TO_LIST, reponseBody)
            }
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },

    [SHIFT_CREATE_REQUEST]: async ({ commit }, body)=>{
        let response = {}
        if(body.id)
            delete body.id
            
        if(body.default_points == 0)
            delete body.default_points
        try {
            response =   await api.post("/catalogs/shifts", body)
            const reponseBody = response.data.body
            if(response.data.statusCode === 200){
                if("created_at_epoch" in reponseBody)
                    commit(ADD_SHIFT_TO_LIST, reponseBody)
            }
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },

    [SHIFT_UPDATE_REQUEST]: async ({state, commit }, body)=>{
        const lodash = require('lodash');
        let response = {}            
        let oldCategory = state.shiftsList.filter(item=>{ return item.id == body.id})
        oldCategory = oldCategory.length > 0 ? oldCategory[0] : {}
        const bodyDifference = lodash.omitBy(body, (value, key) => oldCategory[key] === value);
        try{
            response =   await api.put("/catalogs/shifts/" + body.id, bodyDifference)
            if(response.data.statusCode === 200){
                if(response.data.body.message === "Shift Updated."){
                    commit(UPDATE_SHIFT_IN_LIST, body)
                }
            }
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },

    [SHIFT_DELETE_REQUEST]: async ({ commit }, categoryIDs)=>{
        let response = {}
        try {
            response =   await api.post("/catalogs/shifts/delete", {"ids": categoryIDs})
            const reponseBody = response.data.body

            if(response.data.statusCode === 200){
                if(reponseBody.message === "Shift(s) Deleted." )
                 commit(DELETE_SHIFT_FROM_LIST, categoryIDs)
            }

        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    }

}
